<template>
  <div class="page h-100">
    <div class="container pt-82">
      <div class="mb-30 flex align-center menu justify-center flex-wrap">
        <button class="btn-40 w-107 radius-round mr-10 font-16 font-yahei mb-10" :class="menuIndex === index ? 'bg-c19357 color-ff' : 'bg-ff color-292a2e'" v-for="(item, index) in stylesList" :key="index" @click="chooseMenu(index)">{{item.name}}</button>
      </div>
      <div class="flex align-center mb-30">
        <img src="/images/weizhi.png" alt="" class="mr-10">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/index.html' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item>找品牌</el-breadcrumb-item>
          <el-breadcrumb-item>{{stylesList[menuIndex].name}}</el-breadcrumb-item>
          <el-breadcrumb-item>共{{total}}个品牌</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="flex flex-wrap mb-40">
        <div v-for="(item, index) in brandList" :key="index" class="brand-item" :class="index%4 === 0 ? '' : 'ml-20'" :style="{background:'url(' + Utils.IMG_PREV+item.banner + ') no-repeat center/cover'}" @click="toDetail(item)">
          <div class="main flex align-center justify-center">
            <el-image
              v-if="item.photo"
              style="width:140px;"
              :src="Utils.IMG_PREV+item.photo"
              fit="cover" lazy></el-image>
          </div>
          <div class="mask flex align-center justify-center">
            <div class="btn-40 border-ff radius-round font-16 font-yahei w-124">进入品牌</div>
          </div>
        </div>
      </div>
      <div>
        <el-pagination
          :total="total"
          :page-size="16"
          layout="prev, pager, next">
          @current-change="handleCurrentChange"
        </el-pagination>
        </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Brand',
  components: {},
  props: ['keywords'],
  computed: {},
  data () {
    return {
      stylesList: [{
        name: '全部'
      }],
      menuIndex: 0,
      pageValue: false,
      page: 1,
      limit: 16,
      total: 0,
      brandList: [],
    }
  },
  created () {
    this.getStyle()
    this.getBrand()
  },
  mounted () {
  },
  
  watch: {
    keywords (val) {
      this.keywords = val
      this.getBrand()
    }
  },
  methods: {
    getBrand () {
      this.brandList = []
      let params = {
        page: this.page,
        limit: this.limit,
        style: this.menuIndex > 0 ? this.stylesList[this.menuIndex].name : '',
        keywords: this.keywords
      }
      this.axios.post('brand/queryForPage', params).then(res => {
        if (res.data.success) {
          this.brandList = res.data.data.list
          this.total = res.data.data.total
        } else {
          this.$message({
            message: res.data.msg,
            type: 'error',
            offset: 400
          })
        }
      })
    },
    getStyle() {
      this.axios
        .post("style/list",{})
        .then(res => {
          if (res.data.success) {
            this.stylesList = this.stylesList.concat(res.data.data);
          } else {
            this.$message({
              message: res.data.msg,
              type: "error",
              offset: 400
            });
          }
        });
    },
    chooseMenu (e) {
      this.menuIndex = e
      this.getBrand()
    },
    toDetail (e) {
      let url = this.$router.resolve({name: 'BrandDetail',query: {id: e.id + '.html'}})
      window.open(url.href,'_blank')
    },
    handleCurrentChange (e) {
      console.log(e)
      this.page = e
      this.getBrand()
    },
  }
}
</script>

<style lang="scss" scoped>
  .page{
    background: #eeeff3;
    padding-bottom: 105px;
  }
  .w-107{
    width: 107px;
  }
  .menu{
    button{
      box-shadow: 0px 30px 70px 0px	rgba(192, 146, 87, 0.07);
    }
  }
  .brand-item{
    width: 335px;
    height: 220px;
    border-radius: 4px;
    margin-bottom: 20px;
    cursor: pointer;
    overflow: hidden;
    .main{
      width: 100%;
      height: 100%;
      padding: 20px;
      background: rgba($color: #000000, $alpha: 0.5);
    }
    .mask{
      background: rgba($color: #c19357, $alpha: 0.85);
      width: 100%;
      height: 100%;
      display: none;
    }
    &:hover{
      .main{
        display: none;
      }
      .mask{
        display: flex;
      }
    }
  }
  .w-124{
    width: 124px;
  }
  
</style>
